import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

type SelectStatusType ={
  priority: number
  setPriorityinState: (value: number) => void
}

export const SelectStatusvalue = (props: SelectStatusType) => {
  let str = props.priority.toString()
  const [priority, setPriority] = React.useState(str)

  const handleChange = (event: SelectChangeEvent) => {
    setPriority(event.target.value)
    let number = +event.target.value
    props.setPriorityinState(number)
  };

  return (
    <Box >
      <FormControl  >
        {/* <InputLabel id="demo-simple-select-label">Age</InputLabel> */}
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={priority}
          onChange={handleChange}
        >
          <MenuItem value={1}>1</MenuItem>
          <MenuItem value={2}>2</MenuItem>
          <MenuItem value={3}>3</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}